export class TreeUtils {

  public static TRAVERSE_ALGORITHM = Object.freeze({
    INORDER: 'inorder'
  })

  public static traverse<T>(treeRoot: T, childPropertyName: string, visitor: {(visitedNode: T, depth?: number, siblings?: Array<T>, root?: T): boolean|any}, algorithm: 'inorder' = 'inorder'): boolean {
    if (typeof visitor !== 'function') {
      throw "Visitor must be a function"
    }

    let terminated = false
    let unprocessedChildren: Array<T>= [ treeRoot ]
    let currentDepth = 0, unprocessedChildrenCount : {[depth: number]: number} = { 0: unprocessedChildren.length}
    let currentNode: T, currentNodeChildren: Array<T>
    while (unprocessedChildren.length > 0 && !terminated) {
      // TODO [GitHub Issue]: use shift and change depth calculation
      currentNode = unprocessedChildren.pop()

      currentNodeChildren = Array.isArray(currentNode[childPropertyName]) ? currentNode[childPropertyName] : []
      for (let i = currentNodeChildren.length-1; i >= 0; i--) {
        terminated = false === visitor(currentNodeChildren[i], currentDepth + 1, currentNodeChildren, treeRoot)
        if (terminated) break
      }
      Array.prototype.push.apply(unprocessedChildren, currentNodeChildren)

      currentDepth = TreeUtils.calculateTraverseDepth(currentDepth, unprocessedChildrenCount, currentNodeChildren.length)
    }
    return !terminated
  }

  private static calculateTraverseDepth(currentDepth, unprocessedChildrenCount, currentNodeChildrenCount) {
    const nextDepth = currentDepth + 1
    unprocessedChildrenCount[currentDepth]--
    unprocessedChildrenCount[nextDepth] = (unprocessedChildrenCount[nextDepth] || 0) + currentNodeChildrenCount
    if (unprocessedChildrenCount[nextDepth] > 0) {
      currentDepth++
    } else if (unprocessedChildrenCount[currentDepth] === 0) {
      currentDepth--
    }
    return currentDepth
  }

  // public static map<T>(treeRoot: T, childPropertyName: string, mapFn: {(visitedNode: T, depth?: number, siblings?: Array<T>, root?: T): any}, initialValue?: any): Array<T> {
  //   return TreeUtils.reduce<T>(treeRoot, childPropertyName, (mappedValues, visitedNode, depth, siblings, root) => {
  //     mappedValues.push(mapFn(visitedNode, depth, siblings, root))
  //     return mappedValues
  //   }, [])
  // }

  public static reduce<T>(treeRoot: T, childPropertyName: string, callBackFn: {(previousValue: any, visitedNode: T, depth?: number, siblings?: Array<T>, root?: T): any}, initialValue?: any): any {
    let previousValue = initialValue
    TreeUtils.traverse<T>(treeRoot, childPropertyName, (visitedNode, depth, siblings, root) => {
      previousValue = callBackFn(previousValue, visitedNode, depth, siblings, root)
    })
    return previousValue
  }

  // // TODO [GitHub Issue]: Should this return an array or a copy of the tree? How about a tree and a flatten function?
  // // TODO [GitHub Issue]: Should this be used as a copy function? Maybe something like subtree or copy would be useful as well.
  // public static filter<T>(treeRoot: T, childPropertyName: string, testFn: {(visitedNode: T, depth?: number, siblings?: Array<T>, root?: T): boolean}): Array<T> {
  //   return TreeUtils.reduce<T>(treeRoot, childPropertyName, (filteredValues, visitedNode, depth, siblings, root) => {
  //     if (testFn(visitedNode, depth, siblings, root) === true) {
  //       filteredValues.push(visitedNode)
  //     }
  //     return filteredValues
  //   }, [])
  // }

  public static every<T>(treeRoot: T, childPropertyName: string, testFn: {(visitedNode: T, depth?: number, siblings?: Array<T>, root?: T): boolean}): boolean {
    let everyIsTrue = true
    TreeUtils.traverse<T>(treeRoot, childPropertyName, (visitedNode, depth, siblings, root) => {
      everyIsTrue = everyIsTrue && true === testFn(visitedNode, depth, siblings, root)
      if (!everyIsTrue) return false
    })
    return everyIsTrue
  }

  public static some<T>(treeRoot: T, childPropertyName: string, testFn: {(visitedNode: T, depth?: number, siblings?: Array<T>, root?: T): boolean}): boolean {
    let someAreTrue = false
    TreeUtils.traverse<T>(treeRoot, childPropertyName, (visitedNode, depth, siblings, root) => {
      someAreTrue = testFn(visitedNode, depth, siblings, root)
      if (someAreTrue === true) return false
    })
    return someAreTrue
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/tree-utils.ts